export default {
  accountPages: {
    countryMultiSelect: {
      placeholder: "Select countries",
      allCountries: "All countries",
      removeCountry: "Remove {{name}}",
      loading: "Loading...",
    },
    addCompanyModal: {
      useLatin: "Use the Latin alphabet!",
      title: "Add Company Account",
      description: "To add a new company, please fill in the following fields",
      noPermission: "You don't have permission to create a company.",
      cancel: "Cancel",
      submit: "Add Company",
      close: "Close",
    },
  },
};
